const REQUIRED_ENV = Object.freeze([
  { key: "REACT_APP_SUPABASE_URL", label: "Supabase project URL" },
  { key: "REACT_APP_SUPABASE_ANON_KEY", label: "Supabase anon (public) key" },
]);

export function getMissingRequiredEnv() {
  return REQUIRED_ENV.filter(({ key }) => {
    const value = process.env[key];
    return !value || !String(value).trim();
  });
}

/**
 * Returns a developer-facing message when required build-time env vars are absent.
 * @returns {string | null}
 */
export function validateAppEnv() {
  const missing = getMissingRequiredEnv();
  if (missing.length === 0) {
    return null;
  }

  const variableLines = missing
    .map(({ key, label }) => `- ${key} (${label})`)
    .join("\n");

  return [
    "CrewPilot cannot start: required environment variables are missing.",
    "",
    variableLines,
    "",
    "Local development: copy .env.example to .env and set the values above.",
    "Production: configure these variables in your hosting provider before deploy.",
  ].join("\n");
}
